import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../static/styles/Profile.module.css';
import { isAuthenticated } from '../api/auth';

const Profile = () => {
    const navigate = useNavigate();
    const urlParams = new URLSearchParams(window.location.search);
    useEffect(() => {
        document.title = "Settings | Ufone ESG";
        if(!isAuthenticated()) {
            window.location.href = process.env.REACT_APP_LOGIN_URL;
        }
    }, []);

    const handleLogout = () => {
        const refferer = localStorage.getItem('refferer') || urlParams.get('referer') || urlParams.get('refferer');
        if (refferer == 'gamenow') {
            return;
        }
        localStorage.clear();
        window.location.href = process.env.REACT_APP_LOGIN_URL;
    };

    const handleUnsub = () => {
        const refferer = localStorage.getItem('refferer') || urlParams.get('referer') || urlParams.get('refferer');
        if (refferer == 'gamenow') {
            return;
        }
        navigate("/unsubscribe");
    };

    return (
        <div className={styles.menu}>
            <div className={styles.sectionTitle}>SUPPORT</div>
            <div className={styles.section}>
                <div className={styles.menuItem} onClick={() => navigate('/edit-profile')}>
                    Edit Profile
                    <span className={styles.chevron}>›</span>
                </div>

                <div className={styles.menuItem} onClick={() => navigate('/faqs')}>
                    FAQs
                    <span className={styles.chevron}>›</span>
                </div>
            </div>

            <div className={styles.sectionTitle}>MORE INFORMATION</div>
            <div className={styles.section}>
                <div className={styles.menuItem} onClick={() => navigate('/terms-service')}>
                    Terms of Service
                    <span className={styles.chevron}>›</span>
                </div>
            </div>

            <div className={styles.sectionTitle}>ACCOUNT ACTIONS</div>
            <div className={styles.section}>
                <div className={styles.menuItem} onClick={handleUnsub}>
                    Unsubscribe
                    <span className={styles.chevron}>›</span>
                </div>
                <div className={styles.menuItem} onClick={handleLogout}>
                    Logout
                    <span className={styles.chevron}>›</span>
                </div>
            </div>
        </div>
    );
};

export default Profile;